import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import Cookies from 'js-cookie'

Vue.config.productionTip = false
import 'amfe-flexible/index.js'
import '../src/assets/css/resetui.less'
import '../static/css/reset.css'
import '@/assets/css/index.scss'

import common from '@/utils/common'

Vue.prototype.$common = common

import './permission' // permission control

// import VueAMap from 'vue-amap'; // 高德
// Vue.use(VueAMap);
// VueAMap.initAMapApiLoader({
//   key: 'e60d965201252cb074d1d50ed49747c6',
//   plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor', 'AMap.Geolocation'],
//   v: '1.4.4'
// });


new Vue({
    store,
  router,
  render: h => h(App)
}).$mount('#app')
